import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './FooterPopup.module.css';

const COMPANY_ITEMS = [
  { label: 'About us', content: 'Vendly is Nigeria\'s fastest-growing online marketplace, connecting buyers with verified sellers across the country. Founded in 2024, we\'re on a mission to make quality shopping accessible to every Nigerian.' },
  { label: 'Careers', content: 'We\'re building the future of commerce in Nigeria and we\'re always looking for talented people to join us. Send your CV to careers@vendly.com' },
  { label: 'Blog', content: 'Read our latest articles on shopping tips, seller guides, and product reviews at blog.vendly.com' },
  { label: 'Press', content: 'For press enquiries, partnerships and media requests contact press@vendly.com' },
  { label: 'Sell on Vendly', content: 'Join 10,000+ sellers already making money on Vendly. Register as a seller, list your products and start earning. Seller registration coming soon!' },
];

const SUPPORT_ITEMS = [
  { label: 'Help centre', content: 'Browse our help articles at help.vendly.com or contact us via live chat 24/7. We\'re always here to help.' },
  { label: 'Track order', content: 'Log into your account and go to "My orders" to track your delivery in real time. You\'ll also receive SMS updates.' },
  { label: 'Returns', content: 'Changed your mind? Return any item within 7 days of delivery for a full refund. Visit your orders page and click "Return item".' },
  { label: 'Contact us', content: 'Email: support@vendly.com\nPhone: 0800-VENDLY (0800-836359)\nLive chat: Available 24/7 in the app\nWhatsApp: +234 800 000 0000' },
  { label: 'Privacy policy', content: 'We take your privacy seriously. We never sell your data to third parties. Read our full privacy policy at vendly.com/privacy' },
];

function PopupItem({ label, content }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div ref={ref} className={styles.wrap}>
      <button className={styles.link} onClick={() => setOpen(o => !o)}>{label}</button>
      {open && (
        <div className={styles.popup}>
          <div className={styles.popupHeader}>
            <h4 className={styles.popupTitle}>{label}</h4>
            <button className={styles.popupClose} onClick={() => setOpen(false)}>✕</button>
          </div>
          <p className={styles.popupContent}>{content}</p>
        </div>
      )}
    </div>
  );
}

export function CompanyLinks() {
  return (
    <div className={styles.col}>
      <h4 className={styles.colTitle}>Company</h4>
      {COMPANY_ITEMS.map(item => <PopupItem key={item.label} {...item} />)}
    </div>
  );
}

export function SupportLinks() {
  return (
    <div className={styles.col}>
      <h4 className={styles.colTitle}>Support</h4>
      {SUPPORT_ITEMS.map(item => <PopupItem key={item.label} {...item} />)}
    </div>
  );
}

export function ShopLinks() {
  const navigate = useNavigate();
  const SHOP_CATS = ['Electronics', 'Fashion', 'Home & Living', 'Beauty', 'Sports', 'Deals'];

  return (
    <div className={styles.col}>
      <h4 className={styles.colTitle}>Shop</h4>
      {SHOP_CATS.map(cat => (
        <button
          key={cat}
          className={styles.link}
          onClick={() => navigate('/login')}
        >
          {cat}
        </button>
      ))}
    </div>
  );
}
